import { render, staticRenderFns } from "./PdfTools.vue?vue&type=template&id=50ce465b&scoped=true"
import script from "./PdfTools.vue?vue&type=script&lang=js"
export * from "./PdfTools.vue?vue&type=script&lang=js"
import style0 from "./PdfTools.vue?vue&type=style&index=0&id=50ce465b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ce465b",
  null
  
)

export default component.exports